import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/TrilhasVoitto/Criar/Back";
import Formulario from "../../../../components/Admin/TrilhasVoitto/Criar/Formulario";
const BlogColunistas = props => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Criar Trilhas para Alunos</h2>
        <Divider />
        <Segment>
          <Formulario />
        </Segment>
      </SemanticContainer>
    </>
  );
};

export default withRouter(BlogColunistas);
